import {parseStringEnum, PropsParser, requireString} from "@webng/validations";
import {liveblogRenderPortalTypes, LiveblogRenderPortalTypes} from "@webng/liveblog";

export interface LiveblogPortalWidgetTagProps {
  liveblogId: string
  type: LiveblogRenderPortalTypes
  media: string
}

export interface LiveblogPortalWidgetQueryProps {
}

export interface LiveblogPortalWidgetProps extends LiveblogPortalWidgetTagProps {

}


export const liveblogPortalWidgetTagPropsParser: PropsParser<LiveblogPortalWidgetTagProps> = {
  liveblogId: i => requireString("liveblogId", i),
  type: i => parseStringEnum("type", i, liveblogRenderPortalTypes, "automaticSummary"),
  media: i => i || ""
}

export const liveblogPortalWidgetQueryPropsParser: PropsParser<LiveblogPortalWidgetQueryProps> = {
}


export interface LiveblogPortalWidgetApi {

}
